<div class="page-container">
  <app-toolbar [title]="'CALLS.ADD_CALL.TITLE' | translate"></app-toolbar>
  <div class="page">
    <div class="step-progress-container">
      <app-step-progress [steps]="stepLabels" [currentStep]="1" [disabled]="true"></app-step-progress>
    </div>

    <div class="setup-content">
      @if (data !== null) {
        @let usesNativeBot = orgUsesNativeBot$ | async;
        <div class="step-card">
          <div class="step-header">
            <h3>{{ 'MEETING_SETUP.CREATE_MEETING.STEP_TITLE' | translate }}</h3>
            <p>{{ 'MEETING_SETUP.CREATE_MEETING.DESCRIPTION' | translate }}</p>
          </div>

          <div class="meeting-details-form">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'MEETING_SETUP.MEETING_DETAILS.MEETING_NAME' | translate }}</mat-label>
              <input matInput [(ngModel)]="data.name" required />
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'MEETING_SETUP.MEETING_DETAILS.MEETING_LINK' | translate }}</mat-label>
              <input matInput [(ngModel)]="data.link" required />
            </mat-form-field>
            @if (usesNativeBot && hasShortLink) {
              <p class="link-error">
                {{ 'CALLS.ADD_CALL.TEAMS_SHORT_LINK_NOT_SUPPORTED' | translate }}
                <button
                  type="button"
                  class="link-error-help"
                  (click)="intercomService.openHelpArticle('https://help.wiseworks.ai/en/articles/711338-setting-up-a-teams-meeting-for-brief-ai')"
                >
                  {{ 'CALLS.ADD_CALL.TEAMS_SHORT_LINK_LEARN_MORE' | translate }}
                </button>
              </p>
            }

            <div class="form-row">
              <app-datetime-picker
                [(ngModel)]="data.date"
                [required]="true"
                [isDateInvalid]="isDateTooFarInPast(data.date)"
                errorMessageKey="VALIDATION.DATE_TOO_FAR_IN_PAST"
                translationKey="MEETING_SETUP.MEETING_DETAILS.MEETING_DATE"
              ></app-datetime-picker>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'COMMON.DURATION' | translate }}</mat-label>
                <div class="duration-control">
                  <button
                    mat-icon-button
                    mat-small-icon-button
                    type="button"
                    (click)="$event.stopPropagation(); decreaseDuration()"
                    [disabled]="decreaseDurationButtonDisabled"
                  >
                    <mat-icon>remove</mat-icon>
                  </button>
                  <input matInput readonly [value]="data.duration + ' ' + ('COMMON.MINUTE_ABBREVIATION' | translate)" />
                  <button
                    mat-icon-button
                    mat-small-icon-button
                    type="button"
                    (click)="$event.stopPropagation(); increaseDuration()"
                    [disabled]="increaseDurationButtonDisabled"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </mat-form-field>
            </div>

            @if (organizationUsersWithoutCurrentUser$ | async; as result) {
              @if (result.isSuccess) {
                <app-selection
                  labelKey="COMMON.ADDITIONAL_CALL_OWNERS"
                  idField="id"
                  nameField="fullName"
                  [options]="addFullNameToUserList(result.data!)"
                  (selectionChange)="onUserSelectionChange($event)"
                ></app-selection>
                <div class="disclaimer-box">
                  <mat-icon class="disclaimer-icon">info</mat-icon>
                  {{ 'UPLOAD_CALL.DISCLAIMER' | translate }}
                </div>
              }
            }
          </div>

          <div class="step-actions">
            @if (joinLiveCallMutation.result$ | async; as result) {
              @if (result.isPending) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <button mat-flat-button color="primary" (click)="onCreateCallClicked()" [disabled]="isCreateButtonDisabled || (usesNativeBot && hasShortLink)">
                  {{ 'MEETING_SETUP.MEETING_DETAILS.CREATE_MEETING' | translate }}
                </button>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
